module.exports = __webpack_public_path__ + "static/media/dull_morning.62c4651f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dull_morning.png
// module id = 966
// module chunks = 0